import KickImage from 'Reuseables/KickImage';
import { Col, Row } from 'antd';

import Text from 'Pages/Home/Components/Atoms/Text';
import NotFoundImg from 'images/dashboard-empty-state.png';
import Styles from './EmptySearch.module.scss';
import { TEmptySearch } from './definitions';

export default function EmptySearch({ text, title }: TEmptySearch) {
  return (
    <Row className={Styles['empty-search']} align="middle" justify="center">
      <Col>
        <Row align="middle" justify="center">
          <Col>
            <KickImage
              src={NotFoundImg}
              alt="Not Found"
              className={Styles['empty-search-image']}
            />
          </Col>
        </Row>
        <Row align="middle" justify="center">
          <Col>
            <Text className={Styles['empty-search-title']}>{title}</Text>
          </Col>
        </Row>
        <Row align="middle" justify="center">
          <Col>
            <Text className={Styles['empty-search-text']}>{text}</Text>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
